import type { Styles } from '@adornis/ass/style';
import '@adornis/chemistry/elements/components/x-flex';
import { XProgressBar } from '@adornis/chemistry/elements/components/x-progress-bar';
import { customElement } from 'lit/decorators.js';
import { FPSColors } from '../theme/theme';

/**
 * @element fps-progress-bar
 */
@customElement('fps-progress-bar')
export class FpsProgressBar extends XProgressBar {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        '#progress': {
          background: FPSColors.basicBlue,
        },
      },
    ];
  }
}
